import { useCallback, useEffect, useState } from "react";
import DataTable, { Column, FilterOption } from "../../components/commons/DataTable";
import PayoutAction from "../../components/partials/payout/PayoutAction";
import type { GetPayoutsResponse, PayoutsSearchParams } from "../../services/webServices/payouts/types";
import { getPayouts } from "../../services/webServices/payouts/get";
import { useAdminLoading } from "../../context/AdminLoadingContext";
import { useInitialPageLoad } from "../../components/layouts/admin-layout/useInitialPageLoad";

const PAGE_SIZE = 12;

const filterOptions: FilterOption[] = [
  { value: "waiting", label: "در انتظار پرداخت" },
  { value: "paid", label: "پرداخت شده" },
  { value: "rejected", label: "رد شده" },
];

export default function Payout() {

  const [data, setData] = useState<GetPayoutsResponse[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);

  const { showLoading, hideLoading } = useAdminLoading();
  const isFirstLoad = useInitialPageLoad();

  const fetchPayout = useCallback(async () => {

    if (isFirstLoad) showLoading();
    setIsLoading(true);

    const params: PayoutsSearchParams = {
      limit: PAGE_SIZE,
      offset: (currentPage - 1) * PAGE_SIZE,
    };

    switch (filterValue) {
      case "waiting":
        params.status = 1;
        break;
      case "paid":
        params.status = 5;
        break;
      case "rejected":
        params.status = 6;
        break;
    }

    const response = await getPayouts({ params });

    setData(response);

    if (response.length < PAGE_SIZE) {
      setTotalItems((currentPage - 1) * PAGE_SIZE + response.length);
    } else {
      setTotalItems(currentPage * PAGE_SIZE + 1);
    }

    setIsLoading(false);
    if (isFirstLoad) hideLoading();
  }, [currentPage, filterValue]);

  useEffect(() => {
    fetchPayout();
  }, [fetchPayout]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleFilterChange = (value: string) => {
    setFilterValue(value);
    setCurrentPage(1);
  };

  const handleRenderActions = (row:  GetPayoutsResponse) => {
    return (
      <PayoutAction
        payout={row}
        onActionSuccessed={() => fetchPayout()}
      />
    );
  };

  const columns: Column<GetPayoutsResponse>[] = [
    {
      key: "user",
      header: "کاربر",
      align: "right",
      sortable: true,
      width: "50%",
      accessor: (row) => row.user,
    },
    {
      key: "amount",
      header: "مبلغ",
      align: "right",
      sortable: true,
      width: "15%",
      accessor: (row) => row.amount,
    },
    {
      key: "bank_account",
      header: "حساب بانکی",
      align: "right",
      sortable: false,
      width: "20%",
      accessor: (row) => row.bank_account.iban,
    }
  ];

  return (
    <DataTable
      title="لیست پرداخت‌ها"
      data={data}
      columns={columns}
      loading={isLoading}
      loadingText="در حال بارگذاری پرداخت‌ها..."
      emptyText="پرداختی یافت نشد"

      filterable={true}
      filterPlaceholder="همه وضعیت‌ها"
      filterOptions={filterOptions}
      filterValue={filterValue}
      onFilterChange={handleFilterChange}

      pagination={true}
      serverSidePagination={true}
      currentPage={currentPage}
      onPageChange={handlePageChange}
      totalItems={totalItems}
      pageSize={PAGE_SIZE}

      renderActions={handleRenderActions}
    />
  );
};